export default __webpack_public_path__ + "static/media/line3.af782ccf.svg";